import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { autofill } from 'redux-form';
import Field from '../Field';
import getContactInfo from '../../modules/Profile/services/API/getPersonalData';
import { useQuery } from 'react-query';
import { apiResponseWrapper } from '../../utils/apiResponseWrapper';
import RelativeLoading from '../Loading/RelativeLoading';

function BiggestUserInspection(props) {
  const { children, withoutField = null, formName = null, name = null } = props;
  const { data, isLoading } = useQuery('getContactInfo', async () => {
    const res = await getContactInfo();
    return apiResponseWrapper(res);
  });
  const dispatch = useDispatch();

  const isBiggest = data?.biggestTaxInspection;
  useEffect(() => {
    if (formName && name && isBiggest && !isLoading) {
      dispatch(
        autofill(formName, name, {
          value: data?.biggestTaxInspection?.taxCode,
          label: data?.biggestTaxInspection?.taxName,
        }),
      );
    }
  }, []);

  return (
    <div className={'boo'}>
      {isLoading ? (
        <RelativeLoading />
      ) : (
        <>
          {isBiggest && !withoutField && (
            <Field
              value={`${data?.biggestTaxInspection?.taxCode} - ${data?.biggestTaxInspection?.taxName} `}
              label={'Направить в налоговый орган'}
              isDisabled={true}
            />
          )}
          {isBiggest &&
            withoutField &&
            `${data?.biggestTaxInspection?.taxCode} - ${data?.biggestTaxInspection?.taxName} `}
          {<div className={isBiggest && 'd-none'}>{children}</div>}
        </>
      )}
    </div>
  );
}

export default BiggestUserInspection;

BiggestUserInspection.propTypes = {
  children: PropTypes.any,
  withoutField: PropTypes.bool,
  formName: PropTypes.string,
  name: PropTypes.string,
};
